import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators } = createActions({
  logoutFromWl: null,
  logoutSuccessFromWl: null,
  logoutFailedFromWl: null,
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {};
// Define Reducer
export default createReducer(INITIAL_STATE, {});
